module.exports = __webpack_public_path__ + "img/static__image.54600a26.png";